import React from "react";
import {ComingSooncIcon} from '../svgIcon';

function ComingSoon() {
    return (
            <section className="section-gap wc1-section coming-soon-section"  data-aos="fade">
                <div className="container">
                <div className="text-center">
                    <i className="icon mb-4 d-inline-block">
                        <ComingSooncIcon/>
                    </i>    
                    <h2 className="mb-3">Coming soon...</h2>
                    {/* <p>Sorry we were unable to find any result matching your search criteria. To get more results,<br/> try adjusting your search by changing your filters.</p> */}
                    <p>No relevant data has been found. Please check back later.</p>
                </div>                    
                </div>
            </section>
    );
}
export default ComingSoon;
